import { Link } from "@tanstack/react-router";
import type { CreatorSummary } from "@/api/types";
import { useFollowCreator } from "@/api/queries/creators";
import { Avatar, Button } from "@/components/ui";

type CreatorRowCreator = CreatorSummary & {
  isFollowing: boolean;
  followers?: number;
};

export function CreatorRow({ creator }: { creator: CreatorRowCreator }) {
  const follow = useFollowCreator();
  return (
    <div className="flex h-14 items-center gap-3">
      <Link to="/@{$username}" params={{ username: creator.username }}>
        <Avatar size="lg" imageKey={creator.avatar.key} verified={creator.verified} alt={creator.displayName} />
      </Link>
      <div className="min-w-0 flex-1">
        <Link
          to="/@{$username}"
          params={{ username: creator.username }}
          className="block truncate text-small font-semibold"
        >
          {creator.displayName}
        </Link>
        <span className="text-mono text-text-muted">@{creator.username}</span>
      </div>
      <Button
        size="sm"
        variant="secondary"
        className="rounded-full"
        onClick={() => follow.mutate({ username: creator.username, following: !creator.isFollowing })}
      >
        {creator.isFollowing ? "Following" : "Follow"}
      </Button>
    </div>
  );
}
